module.exports = __webpack_public_path__ + "static/img/4.9f5aafd.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/4.jpeg
// module id = cxcx
// module chunks = 0